import {
  IonButton,
  IonContent,
  IonIcon,
  IonPage,
  IonRouterLink,
  IonText
} from '@ionic/react';

import HeroBackground from '@/assets/images/hero/background.png';
import Logo from '@/components/common/logo/Logo';
import Padding from '@/components/common/padding/Padding';
import Spacer from '@/components/common/spacer/Spacer';
import Faqs from '@/components/landingPage/faqs/Faqs';
import Footer from '@/components/landingPage/footer/Footer';
import { FACEBOOK_MESSENGER_URL } from '@/utils/constants';
import { mailOutline } from 'ionicons/icons';

import './Help.css';

const Help: React.FC = () => {
  const copy = {
    header: (
      <>
        <IonText color="primary">Help</IonText> Center
      </>
    ),
    subHeader: 'How can we help you?',
    contactUs: 'Contact Us',
    emailPrompt: 'Email:',
    email: 'hello@odonto.ph'
  };

  return (
    <IonPage id="help">
      <IonContent>
        <Padding>
          <Logo navigateToRootOnClick={true} />
          <div
            id="helpCenter"
            style={{ backgroundImage: `url(${HeroBackground})` }}
          >
            <Spacer top={42} bottom={8}>
              <Spacer top={16} bottom={12}>
                <h1 className="header">{copy.header}</h1>
              </Spacer>
              <h2 className="subHeader">{copy.subHeader}</h2>
            </Spacer>
            <div id="contactUs">
              <IonButton
                strong={true}
                fill="solid"
                expand="block"
                color="primary"
                onClick={() => {
                  window.open(FACEBOOK_MESSENGER_URL, '_blank');
                }}
              >
                <IonIcon slot="start" icon={mailOutline} />
                {copy.contactUs}
              </IonButton>
              <div id="email">
                <p>{copy.emailPrompt}</p>{' '}
                <IonRouterLink href="mailto:hello@odonto.ph" target="_blank">
                  {copy.email}
                </IonRouterLink>
              </div>
            </div>
          </div>
          <Spacer top={64} />
          <Faqs />
          <Footer />
        </Padding>
      </IonContent>
    </IonPage>
  );
};

export default Help;
